import * as types from "../constants/actionConstants";
import * as questionTypes from "../constants/questionTypeConstants";
import * as portalShared from "../shared/metadataConstantsAndUtilities";
import * as requiredUtils from "../utilities/requiredUtilities";
import * as showGroupUtil from "../utilities/showGroupUtilities";


const initialState ={
    refKey: null,
    metadata: null,
    dataDefObj: null,
    questionnaireInstanceId: null,
    questionnaireInstance: null,
    questionnaireTemplateId: null,
    questionnaireTemplate: null,
    templateObj: null, // PortalPreview
    currPageIndex: 0,
    portalCount: 0
};

const setQuestionDateAnswer = (question, adro) => {

    if (adro.name && adro.answerText) {

        let whichDate = adro.name.split("-")[0]; // Get which date From or To

        // Date Range can be in 4 formats "", "YYYY-MM-DD", ",YYYY-MM-DD" or "YYYY-MM-DD,YYYY-MM-DD"  i.e. "FROM_DATE,TO_DATE"
        let dateArray = question.answerText ? question.answerText.split(",") : [];
        if (whichDate === "dateRangeEntryFrom") {

            if (dateArray.length === 0) {
                // Must hove no answer yet
                question.answerText = adro.answerText;
            } else if (dateArray.length === 2) {
                // Must be "FROM_DATE,TO_DATE"
                question.answerText = adro.answerText + "," + dateArray[1];
            } else if (dateArray.length === 1 && question.answerText.includes(",")) {
                // Must be ",TO_DATE"
                question.answerText = adro.answerText + "," + dateArray[0];
            } else {
                // Must be "FROM_DATE"
                question.answerText = adro.answerText
            }

        } else {
            // Must be "dateRangeEntryTo"
            if (dateArray.length === 0) {
                // Must hove no answer yet
                question.answerText = "," + adro.answerText;
            } else if (dateArray.length === 2) {
                // Must be "FROM_DATE,TO_DATE"
                question.answerText = dateArray[0] + "," + adro.answerText;
            } else if (dateArray.length === 1 && question.answerText.includes(",")) {
                // Must be ",TO_DATE"
                question.answerText = "," + adro.answerText;
            } else {
                // Must be "FROM_DATE"
                question.answerText = question.answerText + "," + adro.answerText
            }
        }

    }

}

function portalReducer(state = initialState, action) {

    let tempQnr = null;
    let tempDataDefObj = null;

    switch (action.type) {
        case types.QUESTIONNAIRE_START:
            return {
                ...state,
                currPageIndex: 0,
                questionnaireInstance: action.data
            };
        case types.QUESTIONNAIRE_GET_FULL_SUCCESS:
            return {
                ...state,
                [action.questionnaire.id]: action.questionnaire
            };
        case types.SET_QUESTIONNAIRE_INSTANCE_NULL:
            return {
                ...state,
                refKey: null,
                questionnaireInstanceId: null,
                currPageIndex: 0,
                questionnaireInstance: {}
            };
        case types.SET_QUESTIONNAIRE_TEMPLATE_SUCCESS:
            return {
                ...state,
                questionnaireTemplateId: action.data.id,
                questionnaireTemplate: action.data.questionnaireTemplate
            };
        case types.SET_QUESTIONNAIRE_TEMPLATE_NULL:
            return {
                ...state,
                refKey: null,
                questionnaireTemplateId: null,
                currPageIndex: 0,
                questionnaireTemplate: {}
            };
        case types.SET_DATA_DEF_OBJ:
            return {
                ...state,
                dataDefObj: action.data.dataDefObj
            };
        case types.GET_QUESTIONNAIRE_INSTANCE_ID_FROM_REF_KEY_SUCCESS:
            return {
                ...state,
                refKey: action.data.refKey,
                metadata: action.data.metadata,
                firstAnswerIndex: null,
                questionnaireInstanceId: action.data.questionnaireId
            };
        case types.GET_QUESTIONNAIRE_READONLY_INSTANCE_ID_FROM_REF_KEY_SUCCESS:
            return {
                ...state,
                refKey: action.data.refKey,
                metadata: action.data.metadata,
                questionnaireInstanceId: action.data.questionnaireId
            };
        case types.GET_QUESTIONNAIRE_INSTANCE_SUCCESS:
            return {
                ...state,
                currPageIndex: 0,
                questionnaireInstance: action.data
            };
        case types.SET_TEMPLATE_OBJ:
            return {
                ...state,
                templateObj: action.data.templateObj
            };
        case types.PORTAL_CURRENT_PAGE:
            return {
                ...state,
                currPageIndex: action.data
            };
        case types.PORTAL_NEXT_PAGE:
            return {
                ...state,
                currPageIndex: ++action.data
            };
        case types.PORTAL_PREV_PAGE:
            return {
                ...state,
                currPageIndex: --action.data
            };
        case types.QUESTION_ANSWER_SUCCESS: {

            let selectedShowGroup = ""; // ZZZZZ Show Group

            tempQnr = portalShared.cloneObj(state.questionnaireInstance); // Clone template instance
            tempDataDefObj = portalShared.cloneObj(state.dataDefObj);

            for (let i = 0; i < tempQnr.questions.length; i++) {

                // Find the Question ID
                if (tempQnr.questions[i].id === action.data.id) {

                    if (tempQnr.questions[i].questionType === questionTypes.RANKING) {

                        // Reorder answers
                        tempQnr.questions[i].answerOptions = action.data.answers;
                        tempQnr.questions[i].answerOptions[0].selected = true; // For RANKING set the first answer to true means CONFIRMED

                        requiredUtils.setSingleAndMultiSelectRequiredAnswered(tempQnr.questions[i], tempQnr.questions[i].answerOptions, tempDataDefObj);
                    }
                    else if (action.data.key === null) {
                        // If the answer key is null, then must be a question type w/o answer objects

                        if (tempQnr.questions[i].questionType === questionTypes.ADDRESS_FULL) {

                            tempQnr.questions[i].addressAnswerDTO = action.data.responseObj.addressAnswer ? action.data.responseObj.addressAnswer: action.data.responseObj.addressAnswerDTO;

                            requiredUtils.handleRequiredAddressQuestions(tempQnr.questions[i], action.data.responseObj.addressAnswerDTO, tempQnr.questions[i].answerOptions, action.data.fromInputType, tempDataDefObj);

                        } else {

                            if (tempQnr.questions[i].questionType === portalShared.DATE_RANGE) {

                                setQuestionDateAnswer(tempQnr.questions[i], action.data.responseObj);

                            } else {
                                tempQnr.questions[i].answerText = action.data.responseObj.answerText; // Set answer
                            }

                            requiredUtils.handleRequiredTextAndDateQuestions(tempQnr.questions[i], tempDataDefObj);
                        }
                    } else {
                        // Single-select and Multi-select

                        let answers = tempQnr.questions[i].answerOptions;

                        // Need to save the show group of the answered question if it has one in case there are other answers with the same show group
                        // And need to save before attempting to process answers because selected may not be the first single select
                        for (let ii = 0; ii < answers.length; ii++) {
                            // Check to see if this is the answer that triggered the reducer
                            if (answers[ii].id === action.data.responseObj.id) {
                                if (tempQnr.questions[i].questionType === questionTypes.CHECKBOX && !action.data.responseObj.selected) {
                                    // For checkboxes if unchecked then save showgroup
                                    selectedShowGroup = (answers[ii].importGroupKeys.length > 0) ? answers[ii].importGroupKeys[0] : ""; // ZZZZZ Show Group
                                }
                                else if (action.data.responseObj.selected) {
                                    selectedShowGroup = (answers[ii].importGroupKeys.length > 0) ? answers[ii].importGroupKeys[0] : ""; // ZZZZZ Show Group
                                }
                            }
                        }

                        for (let j = 0; j < answers.length; j++) {

                            // Find the Answer Key for answered question and deselect any possible previous answers.
                            if (answers[j].key === action.data.key) {

                                answers[j].selected = action.data.responseObj.selected;

                                requiredUtils.handleRequired(tempQnr.questions[i], tempQnr.questions[i].addressAnswerDTO, answers, action.data.fromInputType, tempDataDefObj);
                            } else {
                                switch (tempQnr.questions[i].questionType) {
                                    case questionTypes.RADIO:
                                    case questionTypes.YES_NO:
                                    case questionTypes.LIKERT_RADIO:
                                    case questionTypes.STATE_ONLY:
                                    case questionTypes.ADDRESS_FULL:

                                        if (answers[j].selected) {
                                            answers[j].selected = false;  // Single select, deselect other options

                                            // ------------------------------
                                            // after setting false
                                            // if there is a show group
                                            // call unanswerShowGroupQuestions(tempQnr, tempDataDefObj, tempQnr.questions[i], answers[j].groupKeys[0]);

                                            // Do NOT un-answer if the answer has the shame show group as the new answer
                                            if (answers[j].groupKeys.length > 0 && answers[j].groupKeys[0] !== selectedShowGroup) {
                                                showGroupUtil.unanswerShowGroupQuestions(tempQnr, tempDataDefObj, tempQnr.questions[i], answers[j].groupKeys[0]);
                                            }

                                        }


                                        // Since answered mark question no longer required unless it's an ADDRESS
                                        // if (!tempQnr.questions[i].optional && tempQnr.questions[i].questionType !== questionTypes.ADDRESS_FULL) {
                                        //     requiredUtils.setSingleAndMultiSelectRequiredAnswered(tempQnr.questions[i], answers, tempDataDefObj);
                                        // }
                                        break;
                                    default:
                                        break
                                }
                            }
                        }

                        // ZZZZZ Show Group
                        // !!!!!!!!!!!!!!!!!!! after all single select answers are set to false call unanswerShowGroupQuestions
                        // !!!!!!!!!!!!!!!!!!! MULTI-SELECT  other answers don't get set to false but all their show-group children will
                        // !!!!!!!!!!!!!!!!!!! need to be un-answered when a check box is un-checked, but if checked no children need to be un-answered
                    }

                    break; // Question Answer updated so break out of question loop
                }
            }

            return {
                ...state,
                dataDefObj: tempDataDefObj,
                questionnaireInstance: tempQnr
            };
        }
        case types.QUESTION_TEMPLATE_ANSWER_SUCCESS: {

            tempQnr = portalShared.cloneObj(state.questionnaireTemplate);
            tempDataDefObj = portalShared.cloneObj(state.dataDefObj);

            let category = null;
            let group = null;
            let question = null;
            let answers = null;
            let answer = null;
            let adro = action.data.responseObj; // adro = (action data response object)
            let selectedShowGroup = ""; // ZZZZZ Show Group

            for (let c = 0; c < tempQnr.questionCategoryTemplates.length; c++) {

                category = tempQnr.questionCategoryTemplates[c];

                for (let g = 0; g < category.groupTemplates.length; g++) {

                    group = category.groupTemplates[g];

                    for (let i = 0; i < group.questionTemplates.length; i++) {

                        question = group.questionTemplates[i];

                        // Find the Question ID that triggers the reducer call
                        if (question.id === action.data.id) {

                            // Check for address first, addresses text fields are stored as a JSON obj in addressAnswer
                            // !!! However addressAnswer property is not added to question template until one of the text field is answered
                            // State is stored in answerOptionTemplates
                            if (question.questionType === questionTypes.RANKING) {

                                // Reorder answers
                                question.answerOptionTemplates = action.data.answers;
                                question.answerOptionTemplates[0].selected = true; // For RANKING set the first answer to true means CONFIRMED

                                requiredUtils.setSingleAndMultiSelectRequiredAnswered(question, question.answerOptionTemplates, tempDataDefObj);

                            } else if ((question.questionType === questionTypes.ADDRESS_FULL) && (action.data.fromInputType === "text") && (adro.addressAnswer !== undefined)) {

                                question.addressAnswer = adro.addressAnswer; // Set answer

                                requiredUtils.handleRequiredAddressQuestions(question, adro.addressAnswer, question.answerOptionTemplates, action.data.fromInputType, tempDataDefObj);

                            } else if (action.data.key === null) {

                                // No Template Key means it's NOT a single-select or multi-select
                                // If the answer key is null, then must be a question type w/o answer objects (NOTE: We check for ADDRESS first which also would have had no key

                                if (question.questionType === portalShared.DATE_RANGE) {

                                    setQuestionDateAnswer(question, adro);

                                } else {
                                    question.answerText = adro.answerText; // Set answer
                                }

                                requiredUtils.handleRequiredTextAndDateQuestions(question, tempDataDefObj);

                            } else {

                                // Single Select and Multi-Select (TEMPLATE_MODE)

                                answers = question.answerOptionTemplates;

                                // Need to save the show group of the answered question if it has one in case there are other answers with the same show group
                                // And need to save before attempting to process answers because selected may not be the first single select
                                for (let ii = 0; ii < answers.length; ii++) {
                                    // Check to see if this is the answer that triggered the reducer
                                    if (answers[ii].id === adro.id) {
                                        // For multi-select could be un-answering, so if selected is false don't save selected show group
                                        if (question.questionType === questionTypes.CHECKBOX && !adro.selected) {
                                            // For checkboxes if unchecked then save showgroup
                                            selectedShowGroup = (adro.importGroupKeys.length > 0) ? adro.importGroupKeys[0] : ""; // ZZZZZ Show Group
                                        }
                                        else if (adro.selected) {
                                            selectedShowGroup = (adro.importGroupKeys.length > 0) ? adro.importGroupKeys[0] : ""; // ZZZZZ Show Group
                                        }
                                    }
                                }

                                for (let j = 0; j < answers.length; j++) {

                                    answer = answers[j];
                                    // Find the Answer Key for answered question and deselect any possible previous answers.
                                    // NOTE key here is actually the answer ID
                                    if (answer.id === adro.id) {

                                        // Selected question that triggered reducer

                                        answer.selected = adro.selected;

                                        requiredUtils.handleRequired(question, question.addressAnswer, answers, action.data.fromInputType, tempDataDefObj);

                                    } else {
                                        // Make sure other answers are false
                                        switch (question.questionType) {
                                            case questionTypes.RADIO:
                                            case questionTypes.YES_NO:
                                            case questionTypes.LIKERT_RADIO:
                                            case questionTypes.STATE_ONLY:
                                            case questionTypes.ADDRESS_FULL:

                                                if (answer.selected) {
                                                    answer.selected = false;  // Single select, deselect other options


                                                    // ------------------------------
                                                    // after setting false
                                                    // if there is a show group && the show group does NOT match the show group of the selected
                                                    // This is in the case the same show group is tied to more then one multi-select answer
                                                    // call

                                                    // Do NOT un-answer if the answer has the shame show group as the new answer
                                                    if (answer.importGroupKeys.length > 0 && answer.importGroupKeys[0] !== selectedShowGroup) {
                                                        showGroupUtil.unanswerShowGroupQuestions(tempQnr, tempDataDefObj, question, answer.importGroupKeys[0]);
                                                    }

                                                }


                                                // traverse tree and un-answer any show groups

                                                // Since answered mark question no longer required unless it's an ADDRESS
                                                // if (!question.optional && question.questionType !== questionTypes.ADDRESS_FULL) {
                                                //     requiredUtils.setSingleAndMultiSelectRequiredAnswered(question, answers, tempDataDefObj);
                                                // }
                                                break;
                                            default:
                                                break
                                        }
                                    }
                                }
                            }

                            break; // Question Answer updated so break out of question loop
                        }
                    }
                }
            }

            return {
                ...state,
                dataDefObj: tempDataDefObj,
                questionnaireTemplate: tempQnr
            };
        }
        case types.TEXT_FIELD_CHANGE:

            tempQnr = portalShared.cloneObj(state.questionnaireTemplate);
            tempDataDefObj = portalShared.cloneObj(state.dataDefObj);


            return {
                ...state,
                dataDefObj: tempDataDefObj,
                questionnaireTemplate: tempQnr
            };

        case types.PORTAL_ON_CHANGE_TEXT_ENTRY:

            tempDataDefObj = portalShared.cloneObj(state.dataDefObj);

            if (action.data.question.questionType !== portalShared.DATE_RANGE) {
                requiredUtils.setRequiredAnswered("SRA-18", action.data.id, tempDataDefObj, action.data.value !== "", action.data.helperText);
            }

            return {
                ...state,
                dataDefObj: tempDataDefObj
            };

        case types.INCREMENT_PORTAL_COUNT:
            return {
                ...state,
                portalCount: state.portalCount + 1
            };
        default:
            return state;
    }
}

export default portalReducer;
